class ProhSocialSlider extends HTMLElement {
  connectedCallback() {
    this.viewport = this.querySelector('[data-viewport]');
    this.prevButton = this.querySelector('[data-prev]');
    this.nextButton = this.querySelector('[data-next]');
    this.modal = this.querySelector('[data-modal]');
    this.modalMedia = this.querySelector('[data-modal-media]');
    this.closeButton = this.querySelector('[data-close]');
    if (!this.viewport) return;

    this.handlePrev = this.handlePrev.bind(this);
    this.handleNext = this.handleNext.bind(this);
    this.handleOpen = this.handleOpen.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.handleKeydown = this.handleKeydown.bind(this);

    this.prevButton?.addEventListener('click', this.handlePrev);
    this.nextButton?.addEventListener('click', this.handleNext);
    this.closeButton?.addEventListener('click', this.handleClose);
    this.modal?.addEventListener('click', (event) => {
      if (event.target === this.modal) this.handleClose();
    });

    this.querySelectorAll('[data-social-open]').forEach((trigger) => {
      trigger.addEventListener('click', this.handleOpen);
    });
  }

  disconnectedCallback() {
    this.prevButton?.removeEventListener('click', this.handlePrev);
    this.nextButton?.removeEventListener('click', this.handleNext);
    this.closeButton?.removeEventListener('click', this.handleClose);
    this.querySelectorAll('[data-social-open]').forEach((trigger) => {
      trigger.removeEventListener('click', this.handleOpen);
    });
    document.removeEventListener('keydown', this.handleKeydown);
  }

  getScrollDistance() {
    return this.viewport.clientWidth * 0.9;
  }

  handlePrev() {
    this.viewport.scrollBy({ left: -this.getScrollDistance(), behavior: 'smooth' });
  }

  handleNext() {
    this.viewport.scrollBy({ left: this.getScrollDistance(), behavior: 'smooth' });
  }

  handleOpen(event) {
    const trigger = event.currentTarget;
    const mediaType = trigger.dataset.mediaType;
    const videoUrl = trigger.dataset.videoUrl;
    const tiktokUrl = trigger.dataset.tiktokUrl;

    if (!this.modal || !this.modalMedia) return;

    this.modalMedia.innerHTML = '';

    if (mediaType === 'video_file' && videoUrl) {
      const video = document.createElement('video');
      video.src = videoUrl;
      video.controls = true;
      video.autoplay = true;
      video.playsInline = true;
      this.modalMedia.appendChild(video);
    } else if (mediaType === 'tiktok' && tiktokUrl) {
      const iframe = document.createElement('iframe');
      iframe.src = this.getTikTokPlayerUrl(tiktokUrl);
      iframe.allow = 'autoplay; fullscreen; picture-in-picture';
      iframe.allowFullscreen = true;
      iframe.title = 'TikTok video';
      iframe.className = 'tiktok-video';
      iframe.style.width = '100%';
      iframe.style.height = '100%';
      iframe.style.border = '0';
      this.modalMedia.appendChild(iframe);
    }

    this.modal.hidden = false;
    document.addEventListener('keydown', this.handleKeydown);
    this.closeButton?.focus();
  }

  handleClose() {
    if (!this.modal || !this.modalMedia) return;
    this.modal.hidden = true;
    this.modalMedia.innerHTML = '';
    document.removeEventListener('keydown', this.handleKeydown);
  }

  handleKeydown(event) {
    if (event.key === 'Escape') this.handleClose();
  }

  getTikTokPlayerUrl(url) {
    const videoId = url.split('/video/').pop()?.split('?')[0] || '';
    if (!videoId) return url;
    return `https://www.tiktok.com/player/v1/${videoId}?autoplay=1&mute=1&loop=1`;
  }
}

if (!customElements.get('proh-social-slider')) {
  customElements.define('proh-social-slider', ProhSocialSlider);
}
